import { render, staticRenderFns } from "./GlobalSearchClientTable.vue?vue&type=template&id=48e4df63&"
import script from "./GlobalSearchClientTable.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchClientTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports